import * as d3 from 'd3'
import { get_absolute_coord, pad_number, mk_1st_letter_capital } from './helper.js'
import { update_curr_skeleton } from './FrameView.js'
import { color_dict, data_path, bg_img_style, header_style, icon_class } from './constant.js'
import { frame_info, separate_view_skeleton } from './variable.js'

export function gen_header(header, input_type, label) {

  // Add text
  let input_type_text = header
    .append('text')
    .text(mk_1st_letter_capital(input_type))
    .style('fill', color_dict[input_type])
    .style('font-weight', 'bold')

  let label_text = header
    .append('text')
    .text(' - ' + mk_1st_letter_capital(label))
    .attr('id', `${input_type}-class`)
    .style('fill', color_dict['normal'])
    .style('font-size', header_style['normal-font-size'] + 'px')
    .attr('x', 66)
    .attr('y', 20)
    .style('transform', 'translate(0px, 0px)')
  
  // Arrange the texts
  let arrange_components = [input_type_text, label_text]
  let x = header_style['start']
  let y = (input_type == 'benign') ? '1.3rem' : '1.35rem'
  arrange_components.forEach(e => {
    e.style('transform', 'translate(' + x + 'px,' + y + ')')
    let [x1, y1, x2, y2] = get_absolute_coord(e)
    let w = Math.abs(x2 - x1)
    x = x + w + header_style['between']
  })

  // Set the rectangle width
  x = x + header_style['end'] - header_style['between']
  header.select('.pose-view-header-rect').style('width', x + 'px')

  // Move the header
  if (input_type == 'benign') {
    header.style('transform', 'translate(0px, 3px)')
  }
  else if (input_type == 'attacked') {
    header.style('transform', 'translate(0px,' + (bg_img_style['separate']['height'] - 3) + 'px)')
  }

}

export function gen_background(background, header, input_type) {

  // Add background image
  let bg_img = background
    .append('image')
    .attr('id', `${input_type}-view-bg-img`)
    .attr('href', `${data_path[`${input_type}_frame_dir`]}/frame-${pad_number(frame_info['curr'], 3, 0)}.png`)
    .style('width', bg_img_style['separate']['width'] + 'px')
    .style('height', bg_img_style['separate']['height'] + 'px')
    .attr('preserveAspectRatio', 'xMinYMin meet')

  // Add background mask
  let p = 1.5
  let bg_img_mask = background
  .append('rect')
  .attr('id', `${input_type}-view-bg-img-mask`)
  .style('width', (bg_img_style['separate']['width'] - p) + 'px')
  .style('height', bg_img_style['separate']['height'] + 'px')
  .style('stroke', color_dict['bg-img-border'])
  .style('stroke-width', bg_img_style['separate']['stroke-width'] + 'px')
  .style('fill', 'white')
  .style('opacity', 0.7)

  // Add background image border
  let bg_img_border = background
    .append('rect')
    .attr('id', `${input_type}-view-bg-img-border`)
    .style('width', (bg_img_style['separate']['width'] - p) + 'px')
    .style('height', bg_img_style['separate']['height'] + 'px')
    .style('fill', 'transparent')
    .style('stroke', color_dict['bg-img-border'])
    .style('stroke-width', bg_img_style['separate']['stroke-width'] + 'px')

  // Move the background image and border 
  if (input_type == 'benign') {
    let [x1, y1, x2, y2] = get_absolute_coord(header.select('.pose-view-header-rect'))
    let h = Math.abs(y1 - y2)
    bg_img.style('transform', 'translate(0px,' + h + 'px)')
    bg_img_mask.style('transform', `translate(${p}px, ${h}px)`)
    bg_img_border.style('transform', `translate(${p}px, ${h}px)`)
  } else {
    bg_img_mask.style('transform', `translate(${p}px, 0px)`)
    bg_img_border.style('transform', `translate(${p}px, 0px)`)
  }

}

export function set_view_size(header, input_type) {

  // Get width and height of the view
  let [x1_hd, y1_hd, x2_hd, y2_hd] = get_absolute_coord(header)
  let w_svg = bg_img_style['separate']['width'] + 5
  let h_svg = Math.abs(y1_hd - y2_hd) + bg_img_style['separate']['height']

  // Set width and height of the view
  d3.select(`#${input_type}-view`)
    .style('width', w_svg + 'px')
    .style('height', h_svg + 'px')
  d3.select(`#${input_type}-view-svg`)
    .style('width', w_svg + 'px')
    .style('height', h_svg + 'px')

  // TODO: Remove this later
  if (input_type == 'attacked') {
    // let w = w_svg - 7
    // let h = 50
    let w = 143
    let h = 33
    d3.select('#attacked-view-header')
      .style('height', h + 'px')
      .style('width', w)
    d3.select('#attacked-view-header-rect')
      .style('height', h + 'px')
      .style('width', w + 'px')
    d3.select('#attacked-class')
      // .text('- Exercising with')
      // .text('Wall Pushups')
      .text('- Swing')
      .style('font-size', header_style['normal-font-size'] + 'px')
      .attr('x', 85)
      .attr('y', 21)
      .style('transform', 'translate(0px, 0px)')
    d3.select('#attacked-view-header')
      .append('text')
      // .text('an exercise ball')
      .style('transform', 'translate(10px, 40px)')
      .style('fill', 'white')
      .style('font-size', '13px')
    d3.select('#attacked-view-svg')
      .style('height', '202px')
    d3.select('#attacked-view-header')
      .style('height', '202px')
    d3.select('#attacked-view')
      .style('height', '202px')
  }
  d3.select('#benign-class')
    .style('transform', 'translate(0px, 0px)')
  
}

export function gen_skeleton_range_selection() {

  gen_skeleton_for_one_frame_option()
  gen_skeleton_for_frame_range_option()

  function gen_skeleton_for_one_frame_option() {

    // Check icon
    let check_icon_g = d3.select('#skeleton-one-frame-icon')
      .append('g')
      .attr('id', 'skeleton-one-frame-check-icon')
      .style('display', 'inline-block')

    let check_icon = check_icon_g
      .append('i')
      .attr('class', icon_class['check'])

    // Uncheck icon
    let uncheck_icon_g = d3.select('#skeleton-one-frame-icon')
      .append('g')
      .attr('id', 'skeleton-one-frame-uncheck-icon')
      .style('display', 'none')
      .on('click', function() {
        d3.select(this).style('display', 'none')
        d3.select('#skeleton-one-frame-check-icon').style('display', 'inline-block')
        d3.select('#skeleton-frame-range-check-icon').style('display', 'none')
        d3.select('#skeleton-frame-range-uncheck-icon').style('display', 'inline-block')
        separate_view_skeleton['frame'] = 'one'
        update_curr_skeleton()
      })
    
    let uncheck_icon = uncheck_icon_g
      .append('i')
      .attr('class', icon_class['uncheck'])
      .style('cursor', 'pointer')

    // Add text
    let option_text = document.getElementById('skeleton-one-frame-text')
    option_text.innerText = 'Skeleton for frame 0'
  }

  function gen_skeleton_for_frame_range_option() {

    // Check icon
    let check_icon_g = d3.select('#skeleton-frame-range-icon')
      .append('g')
      .attr('id', 'skeleton-frame-range-check-icon')
      .style('display', 'none')
    
    let check_icon = check_icon_g
      .append('i')
      .attr('class', icon_class['check'])

    // Uncheck icon
    let uncheck_icon_g = d3.select('#skeleton-frame-range-icon')
      .append('g')
      .attr('id', 'skeleton-frame-range-uncheck-icon')
      .style('display', 'inline-block')
      .on('click', function() {
        d3.select(this).style('display', 'none')
        d3.select('#skeleton-frame-range-check-icon').style('display', 'inline-block')
        d3.select('#skeleton-one-frame-check-icon').style('display', 'none')
        d3.select('#skeleton-one-frame-uncheck-icon').style('display', 'inline-block')
        separate_view_skeleton['frame'] = 'range'
        update_curr_skeleton()
      })
    
    let uncheck_icon = uncheck_icon_g
      .append('i')
      .attr('class', icon_class['uncheck'])
      .style('cursor', 'pointer')

    // Add text
    let option_text = document.getElementById('skeleton-frame-range-text')
    option_text.innerText = 'Skeleton for frame 0-10'
  }

}